module.exports = { id: "star", url: "/build/app/img/symbols.svg#star", viewBox: "", toString: function() { return this.url; } };